const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
};

const getUserIPAddress = async (
  token: string // Bearer token
): Promise<any> => {
  const url = `${baseURL}/user/ip-address`;

  try {
    const response = await fetch(url, {
      method: "GET", // Assuming it's a GET request; change to "POST" if needed
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch IP address.");
    }

    return await response.json();
  } catch (error) {
    console.error("IP Address API Error:", error);
    return Promise.reject(error);
  }
};

export { getUserIPAddress };

const toggleUserIPStatus = async (
  token: string, // Bearer token
  payload: { status: boolean } // Assuming you're sending { status: true/false }
): Promise<any> => {
  const url = `${baseURL}/user/enable-disable-user-ip-status`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to enable/disable IP status.");
    }

    return await response.json();
  } catch (error) {
    console.error("Enable/Disable IP Status API Error:", error);
    return Promise.reject(error);
  }
};

export { toggleUserIPStatus };


const saveUserIP = async (
  token: string, // Bearer token
  payload: { ip: string } // Assuming you send IP in this format
): Promise<any> => {
  const url = `${baseURL}/user/save-ip`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      throw new Error("Failed to save IP address.");
    }

    return await response.json();
  } catch (error) {
    console.error("Save IP API Error:", error);
    return Promise.reject(error);
  }
};

export { saveUserIP };

const deleteUserIP = async (
  token: string, // Bearer token
  id: number // IP record ID to delete
): Promise<any> => {
  const url = `${baseURL}/user/delete-ip/${id}`;

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete IP address.");
    }

    return await response.json();
  } catch (error) {
    console.error("Delete IP API Error:", error);
    return Promise.reject(error);
  }
};

export { deleteUserIP };



